var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72 12H24C15.16 12 8 19.12 8 27.88V68.12C8 76.88 15.16 84 24 84H72C80.84 84 88 76.88 88 68.12V27.88C88 19.12 80.84 12 72 12Z",
    fill: "#F2654E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 35H56C54.36 35 53 33.64 53 32C53 30.36 54.36 29 56 29H76C77.64 29 79 30.36 79 32C79 33.64 77.64 35 76 35Z",
    fill: "#F2654E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51H60C58.36 51 57 49.64 57 48C57 46.36 58.36 45 60 45H76C77.64 45 79 46.36 79 48C79 49.64 77.64 51 76 51Z",
    fill: "#F2654E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67H68C66.36 67 65 65.64 65 64C65 62.36 66.36 61 68 61H76C77.64 61 79 62.36 79 64C79 65.64 77.64 67 76 67Z",
    fill: "#F2654E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9998 47.1599C39.1029 47.1599 43.2398 43.023 43.2398 37.9199C43.2398 32.8168 39.1029 28.6799 33.9998 28.6799C28.8967 28.6799 24.7598 32.8168 24.7598 37.9199C24.7598 43.023 28.8967 47.1599 33.9998 47.1599Z",
    fill: "#F2654E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2001 52.44C35.0801 52.24 32.8801 52.24 30.7601 52.44C24.0401 53.08 18.6401 58.4 18.0001 65.12C17.9601 65.68 18.1201 66.24 18.5201 66.64C18.9201 67.04 19.4401 67.32 20.0001 67.32H48.0001C48.5601 67.32 49.1201 67.08 49.4801 66.68C49.8401 66.28 50.0401 65.72 50.0001 65.16C49.3201 58.4 43.9601 53.08 37.2001 52.44Z",
    fill: "#F2654E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.4f8518a7fe7d319387c41ded861c32db.svg";
export { ForwardRef as ReactComponent };